import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import ErrorBoundary from '../error/index'
import Home from '@/pages/home'
import CommonError from '../error/common'

const BasicRoute = (): JSX.Element => (
  <BrowserRouter>
    <ErrorBoundary>
      <Switch>
        <Route
          path="/solar/error"
          render={() => {
            return <CommonError />
          }}
        ></Route>
        <Route
          path="*"
          render={() => {
            return <Home />
          }}
        ></Route>
      </Switch>
    </ErrorBoundary>
  </BrowserRouter>
)
export default BasicRoute
